export const callReminderInclude = 'user,client,building';
